var _ = require('underscore');
var Backbone = require('backbone');
var Marionette = require('marionette');
var Logger = require('Logger');
var EVERYONE = /Everyone/i;
var UPN_TOKEN = /\$UPN/g;
var ROLE_GEOGRAPHY_TOKEN = /\$ROLE-GEOGRAPHY/;
var API = EY.Consultation.Lookups.API.Consultation;

var AccessControl = Backbone.Collection.extend({
    url: API + 'AccessControl'
});

var configure = function () {
    var acl = new AccessControl();
    var user = EY.Consultation.CurrentUser;

    acl.fetch({ filter: { permission: { $regex: 'DISABLED|ENABLED|HIDDEN|VISIBLE' } }, select: { _id: 0 } }).done(function () {
        user.preferences = user.model.get('preferences');
        user.roles = user.model.get('roles');
        user.rolenames = _.chain(user.roles).pluck('roleId').uniq().map(function (id) { return EY.Consultation.Labels['Role_' + id]; }).value().join(', ');
        user.geography = _.chain(user.roles).pluck('geographyId').uniq().value().join('|') || '//';
        user.geographyByRole = _.chain(user.roles).groupBy('roleId').mapObject(function (v) { return _.chain(v).pluck('geographyId').uniq().value().join('|'); }).value();
        user.acl = _.chain(acl.toJSON()).sortBy('order').filter(function (ace) {
            return /\.{/.test(ace.uri) && (EVERYONE.test(ace.roleId) || user.geographyByRole[ace.roleId]);
        }).map(function (ace) {
            var fragments = ace.uri.split('?');

            return _.extend(ace, {
                options: _.last(fragments).replace(UPN_TOKEN, user.upn), // Replace $UPN token if present.
                selector: _.first(fragments).replace(/{|}/g, '')
            });
        }).value(); // Filter down to UI relevant acl.
        user.adminRoles = _.filter(user.roles, function (role) { return /Administrator$/.test(role.roleId); });
        user.adminGeography = _.chain(user.adminRoles).pluck('geographyId').uniq().value().join('|') || '//';
        user.adminGeographyTypePath = _.chain(user.adminRoles).pluck('geographyTypePath').uniq().value().join('|');               
        Logger.log(user.model.id ? '-NamedUser-' : '-UnnamedUser-', user);
    });
};

var match = function (ace, options) {
    var source = JSON.parse(ace.options);
    var target = _.chain(options).pick(_.keys(source)).mapObject(function (v) { return v instanceof Backbone.Model ? v.toJSON() : v; }).value();

    return _.every(source, function (val, key) {
        return !ROLE_GEOGRAPHY_TOKEN.test(ace.uri) ? _.isMatch(target[key], val) : _.every(val, function (v, k) {
            return ROLE_GEOGRAPHY_TOKEN.test(v) ? new RegExp(EY.Consultation.CurrentUser.geographyByRole[ace.roleId]).test(target[key][k]) : _.isEqual(v, target[key][k]);
        }); // If $ROLE-GEOGRAPHY token is present then iterate over source's attributes and perform comparison using regex.
    }); // Match source ACL's options with target View's options. 
};

module.exports.RBAC = Marionette.Behavior.extend({
    defaults: {
        viewName: '' // A string or a function.
    },
    onRender: function () { // This is called after the owning view's onRender.
        var context = this;

        setTimeout(function () {
            context.execute();
        });
    },
    execute: function () {
        var name = this.options.viewName;
        var acl = _.filter(EY.Consultation.CurrentUser.acl, function (ace) {
            return ace.uri.match('^' + name + '\.{') && match(ace, this.view.options);
        }, this); // ACL view's selector pattern: VIEW-NAME.{SELECTOR}?{JSON}

        _.each(acl, function (ace) {
            var $selector = this.$(ace.selector.replace(name + '.', ''));

            switch (ace.permission.toUpperCase()) {
                case 'ENABLED':
                    $selector.removeAttr('disabled').removeClass('disabled');
                    break;
                case 'HIDDEN':
                    $selector.addClass('hidden');
                    break;
                case 'VISIBLE':
                    $selector.removeClass('hidden');
                    break;
                case 'DISABLED':
                default:
                    $selector.attr('disabled', 'disabled').addClass('disabled');
                    break;
            }
        }, this);
        //Logger.log("RBAC - View:" + name + '|ACL:', acl

        // Let's give consumer the ability for further customization, if need be...
        !this.view.isDestroyed() && this.view.triggerMethod("afterAuthorize", acl);
    }
});

module.exports.configure = function () {
    configure();
};


// WEBPACK FOOTER //
// ./js/Modules/Security/Authorization.js